import React from "react";
import { ContactHero } from "../assets/images";
import { BsInstagram, BsWhatsapp, BsTwitter } from "react-icons/bs";
import { BiLogoGmail, BiLogoLinkedin } from "react-icons/bi";

function Contactus() {
  return (
    <div className="pb-10 pt-12 ">
      <div className="relative w-full h-64 md:mt-0 mt-2">
        <img className="w-full h-full object-cover" src={ContactHero} />
        <div className="absolute bg-black bg-opacity-25 w-full h-full top-0"></div>
        <h2 data-aos="fade-up" className="absolute font-semibold text-5xl -mt-32 text-white w-full text-center ">
          Mitra Hukum Anda Untuk Dunia Bisnis
        </h2>
      </div>
      <h2 data-aos="fade-left" className="text-4xl text-center mt-12 font-semibold text-primary">
        Getting Touch <span className="font-bold border-b-secondary border-b-4">With Us</span>
      </h2>
      <p data-aos="fade-right" className="text-center text-md text-primary mt-8">
        Your Journey to Business Dream Start Here !
      </p>
      <div data-aos="flip-left" className="flex justify-center gap-3 my-8">
        <a
          className="mt-3 bg-primary w-12 h-12 p-2.5 text-white rounded-full inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out hover:text-secondary"
          target="_blank"
          href="https://www.instagram.com/tempslawfirm/"
        >
          <BsInstagram className="w-full h-full" />
        </a>
        <a
          className="mt-3 bg-primary w-12 h-12 p-2.5 text-white rounded-full inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out hover:text-secondary"
          target="_blank"
          href="mailto:halotemps@gmail.com"
        >
          <BiLogoGmail className="w-full h-full" />
        </a>
        <a
          className="mt-3 bg-primary w-12 h-12 p-2.5 text-white rounded-full inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out hover:text-secondary"
          target="_blank"
          href="https://wa.me/6281213094426"
        >
          <BsWhatsapp className="w-full h-full" />
        </a>
        <a
          className="mt-3 bg-primary w-12 h-12 p-2.5 text-white rounded-full inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out hover:text-secondary"
          target="_blank"
          href="https://twitter.com/halotemps"
        >
          <BsTwitter className="w-full h-full" />
        </a>
        <a
          className="mt-3 bg-primary w-12 h-12 p-2.5 text-white rounded-full inline-block transform hover:scale-110 transition-transform duration-300 ease-in-out hover:text-secondary"
          target="_blank"
          href="https://www.linkedin.com/in/temps-law-firm-a6803a284/"
        >
          <BiLogoLinkedin className="w-full h-full" />
        </a>
      </div>
    </div>
  );
}

export default Contactus;
